import React from 'react';
import PageBanner from "../../components/sections/front/PageBanner";
import { SingleBlog } from "../../components/single/SingleBlog";
import Image1 from "../../assets/images/blog1.webp";
import Image2 from "../../assets/images/blog2.webp";
import Image3 from "../../assets/images/blog3.webp";
import Image4 from "../../assets/images/blog4.webp";
import Image5 from "../../assets/images/blog5.webp";
import Image6 from "../../assets/images/blog6.webp";
import Image7 from "../../assets/images/blog7.webp";
import Image8 from "../../assets/images/blog8.webp";
import Image9 from "../../assets/images/blog9.webp";


const Banner = {
  title: "Our Blogs",
  description: "Stay informed with insights from the team at Trhurst Tech. Our blogs cover the latest trends in fintech, digital assets, and innovation—curated to help you navigate the future of finance.",
};

const blogList = [
  { id: 1,
    date: "March 6, 2025",
    title: "Introducing the new Trihurst Tech checkout a faster, smarter way to buy and sell crypto.",
    description: "Introducing the new Trihurst Tech checkout — a faster, smarter way to buy and sell crypto. Experience seamless transactions",
    image: Image1,
  },

  { id: 2,
    date: "January 21, 2025",
    title: "Trihurst Tech teams up with Quantaz to enable purchases of EURO, USDD, and Bitcoin.",
    description: "Introducing the new Trihurst Tech checkout — a faster, smarter way to buy and sell crypto. Experience seamless transactions",
    image: Image2 },

  { id: 3,
    date: "January 6, 2025",
    title: "Introducing the new Trihurst Tech checkout — a faster, smarter way to buy and sell Ethereum.",
    description: "Introducing the new Trihurst Tech checkout — a faster, smarter way to buy and sell crypto. Experience seamless transactions",
    image: Image3 },

  { id: 4,
    date: "January 2, 2025",
    title: "Say hello to smarter Litecoin trading with the new Trihurst Tech checkout solution.",
    description: "Introducing the new Trihurst Tech checkout — a faster, smarter way to buy and sell crypto. Experience seamless transactions",
    image: Image4 },

  { id: 5,
    date: "December 26, 2024",
    title: "Introducing the new Trihurst Tech checkout a faster, smarter way to buy and sell crypto.",
    description: "Introducing the new Trihurst Tech checkout — a faster, smarter way to buy and sell crypto. Experience seamless transactions",
    image: Image5 },

  { id: 6,
    date: "December 6, 2024",
    title: "Introducing the new Trihurst Tech checkout a faster, smarter way to buy and sell crypto.",
    description: "Introducing the new Trihurst Tech checkout — a faster, smarter way to buy and sell crypto. Experience seamless transactions",
    image: Image6 },

  { id: 7,
    date: "November 14, 2024",
    title: "Introducing the new Trihurst Tech checkout a faster, smarter way to buy and sell crypto.",
    description: "Introducing the new Trihurst Tech checkout — a faster, smarter way to buy and sell crypto. Experience seamless transactions",
    image: Image7 },

  { id: 8,
    date: "November 10, 2024",
    title: "Introducing the new Trihurst Tech checkout a faster, smarter way to buy and sell crypto.",
    description: "Introducing the new Trihurst Tech checkout — a faster, smarter way to buy and sell crypto. Experience seamless transactions",
    image: Image8 },

  { id: 9,
    date: "November 8, 2024",
    title: "Introducing the new Trihurst Tech checkout a faster, smarter way to buy and sell crypto.",
    description: "Introducing the new Trihurst Tech checkout — a faster, smarter way to buy and sell crypto. Experience seamless transactions",
    image: Image9 },

  { id: 10,
    date: "November 8, 2024",
    title: "Introducing the new Trihurst Tech checkout a faster, smarter way to buy and sell crypto.",
    description: "Introducing the new Trihurst Tech checkout — a faster, smarter way to buy and sell crypto. Experience seamless transactions",
    image: Image6 },
    
  { id: 12,
    date: "November 8, 2024",
    title: "Introducing the new Trihurst Tech checkout a faster, smarter way to buy and sell crypto.",
    description: "Introducing the new Trihurst Tech checkout — a faster, smarter way to buy and sell crypto. Experience seamless transactions",
    image: Image4 },

  { id: 13,
    date: "November 8, 2024",
    title: "Introducing the new Trihurst Tech checkout a faster, smarter way to buy and sell crypto.",
    description: "Introducing the new Trihurst Tech checkout — a faster, smarter way to buy and sell crypto. Experience seamless transactions",
    image: Image2 },

  { id: 14,
    date: "November 8, 2024",
    title: "Introducing the new Trihurst Tech checkout a faster, smarter way to buy and sell crypto.",
    description: "Introducing the new Trihurst Tech checkout — a faster, smarter way to buy and sell crypto. Experience seamless transactions",
    image: Image2 },

  { id: 15,
    date: "November 8, 2024",
    title: "Introducing the new Trihurst Tech checkout a faster, smarter way to buy and sell crypto.",
    description: "Introducing the new Trihurst Tech checkout — a faster, smarter way to buy and sell crypto. Experience seamless transactions",
    image: Image1 },

  { id: 17,
    date: "November 8, 2024",
    title: "Introducing the new Trihurst Tech checkout a faster, smarter way to buy and sell crypto.",
    description: "Introducing the new Trihurst Tech checkout — a faster, smarter way to buy and sell crypto. Experience seamless transactions",
    image: Image9 },

  { id: 18,
    date: "November 8, 2024",
    title: "Introducing the new Trihurst Tech checkout a faster, smarter way to buy and sell crypto.",
    description: "Introducing the new Trihurst Tech checkout — a faster, smarter way to buy and sell crypto. Experience seamless transactions",
    image: Image5 },

  { id: 19,
    date: "November 8, 2024",
    title: "Introducing the new Trihurst Tech checkout a faster, smarter way to buy and sell crypto.",
    description: "Introducing the new Trihurst Tech checkout — a faster, smarter way to buy and sell crypto. Experience seamless transactions",
    image: Image4 },

  { id: 20,
    date: "November 8, 2024",
    title: "Introducing the new Trihurst Tech checkout a faster, smarter way to buy and sell crypto.",
    description: "Introducing the new Trihurst Tech checkout — a faster, smarter way to buy and sell crypto. Experience seamless transactions",
    image: Image8 },

  { id: 21,
    date: "November 8, 2024",
    title: "Introducing the new Trihurst Tech checkout a faster, smarter way to buy and sell crypto.",
    description: "Introducing the new Trihurst Tech checkout — a faster, smarter way to buy and sell crypto. Experience seamless transactions",
    image: Image7 },

  { id: 22,
    date: "November 8, 2024",
    title: "Introducing the new Trihurst Tech checkout a faster, smarter way to buy and sell crypto.",
    description: "Introducing the new Trihurst Tech checkout — a faster, smarter way to buy and sell crypto. Experience seamless transactions",
    image: Image9 }, 

  { id: 23,
    date: "November 8, 2024",
    title: "Introducing the new Trihurst Tech checkout a faster, smarter way to buy and sell crypto.",
    description: "Introducing the new Trihurst Tech checkout — a faster, smarter way to buy and sell crypto. Experience seamless transactions",
    image: Image5 }, 
    
  { id: 24,
    date: "November 8, 2024",
    title: "Introducing the new Trihurst Tech checkout a faster, smarter way to buy and sell crypto.",
    description: "Introducing the new Trihurst Tech checkout — a faster, smarter way to buy and sell crypto. Experience seamless transactions",
    image: Image1 }, 
];

const Blog = () => {
  return (
    <>
      <PageBanner data={Banner} />
      <SingleBlog data={blogList}/>
    </>
  )
}

export default Blog;